<mat-card class="dialog-card compact-card">
  <mat-card-header class="custom-card-header">
    <mat-card-title class="custom-card-title">{{siteName}} Lock Codes</mat-card-title>
  </mat-card-header>
   <mat-card-content class="modal-body">
    <div class="lock-row" *ngIf="hydrolyzerValue !== null">
      <mat-form-field appearance="outline" class="label-field" subscriptSizing="dynamic">
        <mat-label>Type</mat-label>
        <input matInput [value]="hydrolyzerLabel" readonly />
      </mat-form-field>

      <mat-form-field appearance="outline" class="value-field">
        <mat-label>Hydrolyzer Lock code</mat-label>
        <input matInput type="number" [value]="hydrolyzerValue" readonly />
      </mat-form-field>
    </div>

    <!-- MULTIPLE TANK COLORS (GREEN/YELLOW/RED/SOLIDS) -->
    <div class="lock-row" *ngIf="greenValue !== null">
      <mat-form-field appearance="outline" class="label-field greenBG">
        <mat-label>Tank</mat-label>
        <input matInput [value]="greenTankLabel" readonly />
      </mat-form-field>

      <mat-form-field appearance="outline" class="value-field">
        <mat-label>Green Lock code</mat-label>
        <input matInput type="number" [value]="greenValue" readonly />
      </mat-form-field>
    </div>

    <div class="lock-row" *ngIf="yellowValue !== null">
      <mat-form-field appearance="outline" class="label-field yellowBG">
        <mat-label>Tank</mat-label>
        <input matInput [value]="yellowTankLabel" readonly />
      </mat-form-field>

      <mat-form-field appearance="outline" class="value-field">
        <mat-label>Yellow Lock code</mat-label>
        <input matInput type="number" [value]="yellowValue" readonly />
      </mat-form-field>
    </div>

    <div class="lock-row" *ngIf="redValue !== null">
      <mat-form-field appearance="outline" class="label-field redBG">
        <mat-label>Tank</mat-label>
        <input matInput [value]="redTankLabel" readonly />
      </mat-form-field>

      <mat-form-field appearance="outline" class="value-field">
        <mat-label>Red Lock code</mat-label>
        <input matInput type="number" [value]="redValue" readonly />
      </mat-form-field>
    </div>

    <div class="lock-row" *ngIf="solidsValue !== null">
      <mat-form-field appearance="outline" class="label-field blueBG">
        <mat-label>Tank</mat-label>
        <input matInput [value]="solidsTankLabel" readonly />
      </mat-form-field>

      <mat-form-field appearance="outline" class="value-field">
        <mat-label>Solid Lock code</mat-label>
        <input matInput type="number" [value]="solidsValue" readonly />
      </mat-form-field>
    </div>
  </mat-card-content>
  <mat-card-actions align="end" class="modal-footer">
    <button id="btnCloseButton" (click)="onCloseClick()" mat-raised-button color="primary" mat-primary>
      Close
    </button>
  </mat-card-actions>
</mat-card>
<div></div>